import { cn } from "tools/ui";
import Menu from "./Menu";
import { version } from "package_json";

// Phone (<600): full-screen menu in the flow, hidden when closed.
// Tablet (600-1023): off-canvas drawer over the content.
// Desktop (>=1024): static column, openSidebar=true means collapsed (icons).
const style = cn(
  "bg-neutral-800 transition-[width,translate] duration-300 ease-in-out",
  "tablet:block tablet:fixed tablet:top-16 tablet:bottom-0 tablet:left-0 tablet:z-40 tablet:w-72 tablet:shadow-2xl",
  "lg:static lg:z-20 lg:h-full lg:shadow-none lg:translate-x-0",
);

function Sidebar({ openSidebar, routes, handleSidebar, viewportHeight, isDesktop }) {
  const openStyle = openSidebar.value
    ? "max-tablet:flex max-tablet:w-full max-tablet:h-full tablet:translate-x-0 lg:w-20"
    : "max-tablet:hidden tablet:-translate-x-full lg:w-[280px] pb-5";

  return (
    <aside id="sidebar" className={cn(style, openStyle, "flex flex-col")}>
      <div className="flex-1 min-h-0">
        <Menu
          dashMenu={routes}
          openSidebar={openSidebar}
          handleSidebar={handleSidebar}
          isDesktop={isDesktop}
          viewportHeight={viewportHeight}
        />
      </div>
      <p className="mt-auto py-2 text-center text-xs text-gray-400 truncate">
        {openSidebar.value && isDesktop ? `v${version}` : `Versión ${version}`}
      </p>
    </aside>
  );
}

export default Sidebar;
